package dev.krno.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.events.Event

@Composable
fun AppBar() {
    var stuck by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            val next = window.pageYOffset > 8
            if (next != stuck) stuck = next
        }
        window.addEventListener("scroll", listener)
        onDispose { window.removeEventListener("scroll", listener) }
    }

    Header(attrs = {
        classes("bar")
        if (stuck) classes("stuck")
    }) {
        Div(attrs = { classes("bar-in") }) {
            A(href = "#top", attrs = { classes("brand") }) {
                B { Text("BrnKo") }
                Span {
                    Text("Brno Kotlin")
                    Span(attrs = { classes("reg") }) { Text("®") }
                    Text(" User Group")
                }
            }
            Nav {
                A(href = "#program") { Text("Program") }
                A(href = "#speakers") { Text("Speakers") }
                A(href = "#venue") { Text("Venue") }
            }
            Div(attrs = { classes("bar-tools") }) {
                A(href = "#register", attrs = { classes("btn", "btn-fill", "btn-sm") }) {
                    Text("Register")
                }
            }
        }
    }
}
